import { MutationTree } from 'vuex';
import { ManagementTemplatesState } from './types';

export const mutations: MutationTree<ManagementTemplatesState> = {
    setManagementTemplates: (state, data) => {
        state.managementTemplates = data;
    },
    setManagementTemplatesItem: (state, data) => {
        state.managementTemplatesItem = data;
    }
};
